import {
    ACTION_GET_TIPS,
    ACTION_POST_CREATE_TIPS,
    ACTION_PUT_UPDATE_TIPS,
    ACTION_DELETE_TIPS,
    SET_TIPS
} from "./types/types.js";

import { TipsCategoriesService } from "../../../services";
import i18n from '@/plugins/i18n';
import Swal from 'sweetalert2';

const actions = {
    [ACTION_GET_TIPS]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");
                console.log("Action idEmpresa: ", idEmpresa);

                TipsCategoriesService.getTips(idEmpresa, idUsuario)
                .then(resp => {
                    if (resp && resp.data && resp.data.payload) {
                        commit(SET_TIPS, resp.data.payload);
                        resolve(resp);
                    } else {
                        reject(new Error('Invalid response format'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => {
                    state.loading = false;
                });
            } catch (error) {
                reject(error);
            }
        });
    },

    [ACTION_POST_CREATE_TIPS]: ({ state }, tip) => {
        const data = {
            happinessCategoryTipsName: tip.happinessCategoryTipsName,
            status: tip.status !== undefined ? tip.status : true
        };

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                TipsCategoriesService.createTip(idEmpresa, idUsuario, data)
                .then(async (resp) => {
                    if (resp && resp.status === 200) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('tips.actionPostCreateTips.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                    } else {
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_PUT_UPDATE_TIPS]: ({ state }, tip) => {
        const data = {
            happinessCategoryTipsName: tip.happinessCategoryTipsName,
            status: tip.status !== undefined ? tip.status : true
        };

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                TipsCategoriesService.updateTip(idEmpresa, idUsuario, tip.tipId, data)
                .then(async (resp) => {
                    if (resp && resp.status === 200) {
                        await Swal.fire({
                            position: 'top-end',
                            icon: 'success',
                            title: i18n.t('tips.actionPutUpdateTips.success'),
                            showConfirmButton: false,
                            timer: 2500
                        });
                        resolve(resp);
                    } else {
                        reject(i18n.t('label.actionReject'));
                    }
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_DELETE_TIPS]: ({ state }, tipId) => {
        state.loading = true;
        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                TipsCategoriesService.deleteTip(idEmpresa, idUsuario, tipId)
                .then(async (resp) => {
                    await Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: i18n.t('tips.actionDeleteTips.success'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => state.loading = false);
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    }
};

export default actions;
